var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7773_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 16.5C12.418 16.5 15.9998 12.9183 15.9998 8.5C15.9998 4.08172 12.418 0.5 7.99976 0.5C3.58148 0.5 -0.000244141 4.08172 -0.000244141 8.5C-0.000244141 12.9183 3.58148 16.5 7.99976 16.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5024 11.2826C15.824 10.4159 16 9.47856 16 8.5C16 7.52144 15.824 6.58406 15.5024 5.71741H0.497594C0.176031 6.58406 0 7.52144 0 8.5C0 9.47856 0.176031 10.4159 0.497594 11.2826L8 11.9783L15.5024 11.2826Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 16.5C11.4397 16.5 14.372 14.329 15.5024 11.2826H0.497559C1.6279 14.329 4.56025 16.5 7.99996 16.5Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7773_5242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussia);
export default __webpack_public_path__ + "static/media/Russia.7babc9eb09ae942deb872bf021291e0a.svg";
export { ForwardRef as ReactComponent };